var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"px-2 transition duration-150 ease-in-out font-sans font-medium tracking-widest",class:[_vm.css, _vm.classes],staticStyle:{"padding-top":"3px","padding-bottom":"3px"}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.label ? _vm.label : ''))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }